import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { sha256Hash } from '../sha256-hash';
import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

export const onErrorStateSuggestedQueryClick: ({
	errorStateSuggestedQuery,
	...props
}: commonAttributesType & {
	errorStateSuggestedQuery: string;
}) => AnalyticsEventPayload = ({
	errorStateSuggestedQuery,
	...props
}: commonAttributesType & {
	errorStateSuggestedQuery: string;
}): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiErrorStateSuggestedQuery',
		source: source,
		eventType: 'ui',
		attributes: {
			...filterCommonAttributes(props),
			errorStateSuggestedQueryHash: sha256Hash(errorStateSuggestedQuery),
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
			errorStateSuggestedQuery,
		},
	};
};
